/**
 * Why a theme field would be refused — the same contract the server checks
 * (`orgThemeNameSchema`, `orgThemeDefinitionSchema` in `@aica/api-types`),
 * read as a reason the form can say next to the field instead of a silently
 * disabled button.
 */
import { orgThemeDefinitionSchema, orgThemeNameSchema } from '@aica/api-types/schemas';

/** `empty` — nothing typed yet: the button waits, no message. */
export type ThemeFieldProblem = 'empty' | 'noLetter' | 'invalidCharacters' | 'tooLong';

export function themeFieldProblem(
  field: 'name' | 'definition',
  value: string
): ThemeFieldProblem | null {
  const schema = field === 'name' ? orgThemeNameSchema : orgThemeDefinitionSchema;
  const result = schema.safeParse(value);
  if (result.success) return null;
  const codes = new Set(result.error.issues.map((issue) => issue.code));
  if (codes.has('too_small')) return 'empty';
  if (codes.has('invalid_format')) return 'invalidCharacters';
  if (codes.has('too_big')) return 'tooLong';
  // The remaining refinement of a name: it has no letter or digit.
  return 'noLetter';
}
